@if (state.isReady()) {
  <div>
    <ch-news-list [editable]="true"></ch-news-list>
  </div>
} @else {
  <ch-status [state]="state"></ch-status>
}
